import { SET_PERSON, SET_PERSONS } from "../../constants/personConstants";

export const setPerson = (person) => {
  return {
    type: SET_PERSON,
    person,
  };
};

export const setPersons = (persons, personType, filtered = false) => {
  return {
    type: SET_PERSONS,
    persons,
    personType,
    filtered,
  };
};
